export default __webpack_public_path__ + "static/media/Email.9a6e87aa.svg";